<template>
  <div class="slide slide-section-divider">
    <!-- Left Panel (Dark) -->
    <div class="left-panel">
      <div class="watermark-number">{{ data.number }}</div>
      <div class="section-label">
        <span class="mono-text">SECTION {{ data.number }}</span>
      </div>
    </div>

    <!-- Right Panel (Light) -->
    <div class="right-panel">
      <div class="decorative-line"></div>
      <h2 class="section-title">{{ data.title }}</h2>
      <p class="section-subtitle" v-if="data.subtitle">{{ data.subtitle }}</p>
      <div class="decorative-dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionDividerSlide',
  props: {
    data: {
      type: Object,
      required: true
    },
    slideId: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/quarterly-slides.scss';

.slide-section-divider {
  @extend .slide-base;
  display: flex;
  overflow: hidden;
}

.left-panel {
  width: 45%;
  background: $ink;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px;
}

.watermark-number {
  position: absolute;
  font-family: $font-display;
  font-style: italic;
  font-size: 30vw;
  color: rgba(255, 255, 255, 0.06);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1;
  user-select: none;
}

.section-label {
  position: relative;
  z-index: 1;

  .mono-text {
    @extend .mono-label;
    color: $violet-300;
    font-size: 14px;
    letter-spacing: 0.15em;
  }
}

.right-panel {
  width: 55%;
  background: $paper;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 100px;
  position: relative;
}

.decorative-line {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, $violet-500, $violet-300);
  margin-bottom: 40px;
  border-radius: 2px;
}

.section-title {
  @extend .serif-headline;
  font-size: 72px;
  color: $ink;
  margin: 0 0 24px;
  line-height: 1.1;
}

.section-subtitle {
  font-family: $font-body;
  font-size: 24px;
  color: $ink-muted;
  margin: 0;
  max-width: 500px;
  line-height: 1.5;
}

.decorative-dot {
  position: absolute;
  bottom: 80px;
  right: 80px;
  width: 16px;
  height: 16px;
  background: $violet-500;
  border-radius: 50%;
}
</style>
